export default function predictiveSearch() {
	return {
		query: "",
		results: "",
		isOpen: false,
		isLoading: false,
		abortController: null,

		init() {
			this.query = this.$refs.input?.value || "";
		},

		open() {
			if (this.query.trim().length >= 2) {
				this.isOpen = true;
			}
		},

		close() {
			this.isOpen = false;
		},

		onInput() {
			const q = this.query.trim();
			if (q.length < 2) {
				this.results = "";
				this.isOpen = false;
				if (this.abortController) this.abortController.abort();
				this.isLoading = false;
				return;
			}
			this.isOpen = true;
			this.fetchResults(q);
		},

		async fetchResults(q) {
			if (this.abortController) this.abortController.abort();
			this.abortController = new AbortController();

			this.isLoading = true;

			const params = new URLSearchParams({
				q,
				section_id: "predictive-search",
				"resources[type]": "product,collection,page,query",
				"resources[limit]": "4",
				"resources[options][unavailable_products]": "last",
				"resources[options][prefix]": "last",
			});

			try {
				const response = await fetch(
					`${window.Shopify.routes.root}search/suggest?${params.toString()}`,
					{ signal: this.abortController.signal }
				);
				if (!response.ok) throw new Error("Predictive search request failed");
				const html = await response.text();
				this.results = html;
				this.isLoading = false;
			} catch (error) {
				if (error.name === "AbortError") return;
				console.error(error);
				this.isLoading = false;
			}
		},
	};
}
